import { BundleStatusReportPanel } from '@/components/ParticipantTracker/BundleStatusReportPanel';

import { Layout } from '../components/Layout';
import { PVForm } from '../components/PVForm';

export const PVSelect = () => {
  return (
    <Layout title="Manage Devices | Vivid Vision Perimetry" secondary={<BundleStatusReportPanel />}>
      <PVForm />
    </Layout>
  );
};
